<template>
  <div class="flex items-center space-x-5">
    <button class="link flex items-center space-x-2" @click="$emit('prev')">
      <svg class="w-3 h-3 fill-current" viewBox="0 0 6.3 11.1">
        <path d="M5.6 0l.7.7-4.9 4.9 4.9 4.8-.7.7L0 5.6z" />
      </svg>
      <span>Prev</span>
    </button>
    <div class="h-5 w-px bg-theme"></div>
    <button class="link flex items-center space-x-2" @click="$emit('next')">
      <span>Next</span>
      <svg class="w-3 h-3 fill-current" viewBox="0 0 6.3 11.1">
        <path d="M.7 11.1l-.7-.7 4.9-4.8L0 .7.7 0l5.6 5.6z" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "Pagination",
};
</script>
